// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"742c9a55","172":"346bac69","361":"60557925","673":"ca23c999"}[chunkId] + ".chunk.js";
};